import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatSurveyDate(date: Date, language: string) {
    return new Date(date).toLocaleDateString(language.startsWith("nb") ? "nb-NO" : "en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
}
